import { FC, ReactNode } from 'react';
import { NavDropdown } from 'react-bootstrap';

interface MenuDropDownProps {
  title: string;
  children: ReactNode;
  onSelect?: (id: string | null) => void;
}

const MenuDropDown: FC<MenuDropDownProps> = ({ title, children, onSelect }) => {
  return (
    <NavDropdown title={title} onSelect={onSelect}>
      {children}
    </NavDropdown>
  );
};

export default MenuDropDown;
